// extracted by mini-css-extract-plugin
module.exports = {"legal":"legal_legal__1NyQG"};